<script>
import Logo from '@/components/Logo.vue'
export default {
    components: { Logo },
  data() {
    return {  
      showMobileMenu: false,
        links: [ 
            {title: 'Hem', scrollId: 'happy_girl' },
            {title: 'Vad är JAMII', scrollId: 'banana_box' },
            {title: '4 goda anledningar att välja JAMII', scrollId: 'four_good_reasons' },
            {title: 'Skapat med JAMII', scrollId: 'created_with_jamii' },
            {title: 'Våra produkter', scrollId: 'our_products' },
            {title: 'Beställ', scrollId: 'our_products' },
        ],
        selectedSection: 'saleHome'
    }
  }, 
  methods:
  {
    goTopage(link)
    {
      const element = document.getElementById(link.scrollId);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80, // Adjust offset as needed for fixed header
          behavior: 'smooth'
        });
      }
       
      this.showMobileMenu = false;
      this.selectedSection = link.title;
    },
  },
  watch:
  {
    customerName(newvalue)
    {
      document.title = newvalue;
    }
  },
  computed: {  
    height() { return $(window).height() },
    selectedPage() { return this.$route.name }
  },
}
</script>
<template>
  <section class="MobileMenu">
    <img src="@/assets/imgs/new_logo.png">   
    <div class="MobileMenu-icon">     
      <p @click="showMobileMenu = !showMobileMenu">             
        <hr :class="showMobileMenu ? 'MobileMenu-line-fade-out' : 'MobileMenu-line-fader'">
        <hr :class="showMobileMenu ? 'MobileMenu-line-x' : 'MobileMenu-line-x-straight'">
        <hr :class="showMobileMenu ? 'MobileMenu-line-y' : 'MobileMenu-line-y-straight'">
        <hr :class="showMobileMenu ? 'MobileMenu-line-fade-out' : 'MobileMenu-line-fader'">        
      </p>     
    </div>
    <div v-if="showMobileMenu" v-fade-in="0">            
        <div class="MobileMenu-links" style="" :style="{ 'height': height + 'px' }">
           <li v-for="link in links" @click="goTopage(link)" :style="{'color': link.title == selectedSection ? '#f25c43' : ''}">
            {{  link.title }}
          </li> 
        </div>  
        
      </div>  
  </section>
</template>


<style scoped>

li{ 
    display: block;
    padding: 20px 5vw;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px;
    position: relative;
}

li:hover {
    color: #f25c43 !important;
    background-color: rgba(242, 92, 67, 0.08);
    transform: translateY(-1px);
}

li:active {
    transform: translateY(0px);
    transition: all 0.1s ease;
}

.MobileMenu-icon
{
  overflow: auto; 
  position: absolute; 
  z-index: 100; 
  right: 0px;
}

.MobileMenu img
{
      width: 144px;
    float: left;
}

.MobileMenu-links
{
  position: absolute; 
  width:100%; 
  z-index: 10; 
  top: 80px;
  left: 0px;
  text-align: center;
  padding-bottom:95px;
  padding-top: 15px;  
  background-color: white;
}

.MobileMenu-links img
{ 
  width:160px; 
}
.MobileMenu
{ 
 
   color: rgb(0, 0, 0);
  position: fixed;
  z-index: 999;
  top: 0px;
  left: 0px;
  right: 0px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 16pt;
  background-color: white;
  padding: 10px 0px 6px 11px;
  opacity: 0.96;
}

  .MobileMenu p 
  {
    font-size: 11pt;
    font-weight: bold;
    text-align: center;
    margin: 17px 30px;
    width: 45px;
    float: right;
    cursor: pointer;
  }  
  .MobileMenu hr {
    height: 5px;
    width: 40px;
    margin: 2px;
    float: right;
    background: black;
    border-radius: 4px;
    border: 1px solid black;
  }  

.MobileMenu-line-fade-out
{
  opacity: 0;
  transition: 0.3s;
}
.MobileMenu-line-x
{
  transform: rotate(135deg);
  transition: 0.3s;
}
.MobileMenu-line-y
{
  transform: rotate(45deg);
  transition: 0.3s;
  position: absolute;
  top: 28px;
  right: 30px;
}
.MobileMenu-line-y-straight
{
  transform: rotate(0deg);
  transition: 0.3s;
  position: absolute;
  opacity: 0;
  top: 28px;
  right: 30px;
}
.MobileMenu-line-x-straight
{
  transform: rotate(180deg);
  transition: 0.3s;
}
.MobileMenu-line-fader
{
  opacity: 1;
  transition: 0.6s;
}
</style>
